import React, { useState } from 'react';
import { Table, TableBody, TableCell, TableHead,  TableRow, TableSortLabel} from '@material-ui/core';
import Label from "../label/Label";
import './SortableTable.css'

function SortableTable({ data = [{}], options = {} } = {}) {
    const {
        loadSortConfig = () => ({key: null, direction: 'asc'}),
        onSortConfigSet = () => {},
    } = options;
    const [{data: rowData = []} = {}] = data;
    const [sortConfig, setSortConfig] = useState(loadSortConfig());
    const headers = rowData.map(r => r.column)

    const requestSort = (key) => {
        let direction = 'asc';
        if (sortConfig.key === key && sortConfig.direction === 'asc') {
            direction = 'desc';
        }
        setSortConfig({ key, direction });
        onSortConfigSet({ key, direction })
    };

    const sortedData = [...data].sort((a, b) => {
        if (sortConfig.key) {
            const {data: rows = []} = a;
            const {data: bRows = []} = b;

            const aRow = rows.find(r => r.column === sortConfig.key) || {}
            const bRow = bRows.find(r => r.column === sortConfig.key) || {}

            const {value: aValue} = aRow;
            const {value: bValue} = bRow;

            // If either value is a null, undefined or empty string sort to the bottom on asc sort
            // and the top on desc sort
            if (aValue == null && bValue == null) return 0;
            if (aValue === '' && bValue === '') return 0;
            if ((aValue == null || aValue === '')  || (bValue == null || bValue === '')) {
                if (aValue == null || aValue === '') return sortConfig.direction === 'desc' ? -1 : 1;
                if (bValue == null || bValue === '') return sortConfig.direction === 'desc' ? 1 : -1;
            }

            // Comparing two numbers
            if (typeof aValue === 'number' && typeof bValue === 'number') {
                return sortConfig.direction === 'asc' ? aValue - bValue : bValue - aValue;
            }

            // Comparing two strings
            if (typeof aValue === 'string' && typeof bValue === 'string') {
                const compared = aValue.localeCompare(bValue);
                if (compared !== 0 && sortConfig.direction === 'desc') return compared * -1
                return  compared
            }
            // Fallback for all other compare types
            if (aValue < bValue) return sortConfig.direction === 'asc' ? -1 : 1;
            else if (aValue > bValue) return sortConfig.direction === 'asc' ? 1 : -1;
            return 0;
        }
        return 0;
    });

    const renderHeader = (header, index) => {
        const {disabled = []} = options;
        const isDisabled = disabled.includes(header)
        return (
            <TableCell key={index}>
                {isDisabled ? header : (
                    <TableSortLabel
                        active={sortConfig.key === header}
                        direction={sortConfig.key === header ? sortConfig.direction : 'asc'}
                        onClick={() => requestSort(header)}
                    >
											<Label black bold> {header}</Label>
                    </TableSortLabel>
                )}
            </TableCell>
        );
    }

    const renderRow = (row = {}, index) => {
        const {data: rowObjects = [], onClick = (() => {})} = row;
        const values = headers.map(header => {
            const cell = rowObjects.find(d => d.column === header) || {}
            const {value, children} = cell
            return children ? children : value;
        })
        return (
            <TableRow onClick={onClick} key={index}>
                {values.map((value, i) => (<TableCell key={i}>{value}</TableCell>))}
            </TableRow>
        )
    }

    return (
        <Table>
            <TableHead>
                <TableRow>{headers.map(renderHeader)}</TableRow>
            </TableHead>
            <TableBody>{sortedData.map(renderRow)}</TableBody>
        </Table>
    );
}

export default SortableTable;



// WEBPACK FOOTER //
// ./src/components/sortableTable/SortableTable.jsx